import React, { useContext } from 'react'
import { StyledHeaderWithStats } from './styled'
import { Col, Row, Grid } from 'react-flexbox-grid'
import WeatherAndDate from './components/WeatherAndDate'
import BranchList from './components/BranchList'
import StatsList from './components/StatsList'
import moment from 'moment'
import { dateFormat } from 'pages/BranchDetails/BranchDetails'
import { DashboardContext } from 'components/DashboardContext'

const HeaderWithStats = (props) => {
	const {
		title, geoData, shopId,
		currentShop, changeShop,
		type = 'notBranchDetails'
	} = props
	const {
		mainCurrency,
		activeDate,
		branchList,
		dateIsToday
	} = useContext(DashboardContext)
	const formatedDate = moment(activeDate).format(dateFormat)
	const isBranchDetailsPage = type === 'branchDetails'
	let leftSideContet, leftSideProps
	if(isBranchDetailsPage) {
		leftSideProps = {
			title, geoData,
			formatedDate, shopId
		}
		leftSideContet = <WeatherAndDate {...leftSideProps}/>
	}else{
		leftSideProps = {
			title, changeShop,
			currentShop, branchList
		}
		leftSideContet = <BranchList {...leftSideProps} />
	}

	return(
		<StyledHeaderWithStats>
			<Grid className='defaultGrid'>
				<Row className='row headerRow headerRow_branch'>
					<Col
						className='col leftSide'
						xl={5}
						xlOffset={0}
						md={7}
						mdOffset={0}
						sm={6}
						smOffset={0}
					>
						{ leftSideContet }
					</Col>
					<Col
						className='col rightSide'
						xl={7}
						xlOffset={0}
						md={5}
						mdOffset={0}
						sm={6}
						smOffset={0}
					>
						<StatsList
							shopId={isBranchDetailsPage ? shopId : currentShop}
							mainCurrency={mainCurrency}
							formatedDate={formatedDate}
							branchList={branchList}
							dateIsToday={dateIsToday}
						/>
					</Col>
				</Row>
			</Grid>
		</StyledHeaderWithStats>
	)
}

export default HeaderWithStats
